import type { GroupCollectionConfig } from './types';

export function readGroupCollection(obj: {
  groupCollection?: GroupCollectionConfig;
}): GroupCollectionConfig | undefined {
  const cfg = obj.groupCollection;
  if (!cfg) return undefined;

  if (cfg.type === 'equispaced') {
    if (typeof cfg.size !== 'number') return undefined;
    if (cfg.direction !== 'row' && cfg.direction !== 'column') return undefined;
    return cfg;
  }

  if (cfg.type === 'grid') {
    if (typeof cfg.width !== 'number' || typeof cfg.height !== 'number') return undefined;
    return cfg;
  }

  return undefined;
}
